import { render, staticRenderFns } from "./CartSummary.vue?vue&type=template&id=52cf08de&"
import script from "./CartSummary.vue?vue&type=script&lang=ts&"
export * from "./CartSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports